export let StringUtility = {
    containsUpperCaseLetter: function (string: string) {
        return /[A-Z]+/.test(string);
    },

    containsNumber: function (string: string) {
        return /[\d]+/.test(string);
    },

    containsSpecialCharacter: function (string: string) {
        return /[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]+/.test(string);
    },

    stringNumberToDisplayCurrency: function (string: string) {
        const formatter = new Intl.NumberFormat(
            'en-US',
            {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 2,
            }
        );
        return formatter.format(parseFloat('' + string))
    },
};
